import { useEffect, useState } from 'react';
import NachWrapper from '../components/NachWrapper';
import RedirectLinkForm from './components/RedirectLinkForm';
import SourceTypeChoose from './components/SourceTypeChoose';
import AutoPay from './components/AutoPay';
import Pnach from './components/Pnach';
import Enach from './components/Enach';
import { useLocation } from 'react-router-dom';
import { NotFound } from 'common/components';
import {
  getNachMandateDetails,
  getNachMandateDetailsResponseData,
  nachBankDetailType,
} from 'api/nach';
import Loading from '../components/Loading';
import moment from 'moment';
import NoDataFound from '../components/NoDataFound';

function CustomerRedirectLink() {
  // const [checkedRecord, setCheckedRecord] = useState<any>();
  const [mandateLinkData, setMandateLinkData] = useState<getNachMandateDetailsResponseData>(
    {} as getNachMandateDetailsResponseData
  );
  const [sourceType, setSourceType] = useState<string>('');
  const [autoPay, setAutoPay] = useState<boolean>(false);
  const [enach, setEnach] = useState<boolean>(false);
  const [pnach, setPnach] = useState<boolean>(false);
  // const [autoPayBankData,setAutoPayBankData]=useState<nachBankDetailType>({} as nachBankDetailType);
  const [enachBankData, setEnachBankData] = useState<nachBankDetailType>({} as nachBankDetailType);
  const [pnachBankData, setPnachBankData] = useState<nachBankDetailType>({} as nachBankDetailType);
  const [autoPayBankData, setAutoPayBankData] = useState<nachBankDetailType>(
    {} as nachBankDetailType
  );
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLinkExpired, setIsLinkExpired] = useState(false);

  // console.log('Bank code ', bankCode);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const mandateId = searchParams.get('mandateId');

  if (!mandateId || !isNumeric(mandateId)) {
    return <NotFound />;
  }
  function isNumeric(value: string): boolean {
    return !isNaN(parseFloat(value)) && isFinite(parseFloat(value));
  }

  useEffect(() => {
    setIsLoading(true);
    const startDate = moment(new Date()).format('YYYY/MM/DD HH:mm:ss');
    const datePlus25Years = moment().add(25, 'years').format('YYYY/MM/DD HH:mm:ss');
    debugger;
    getNachMandateDetails({ mandateId: parseInt(mandateId), startDate, endDate: datePlus25Years })
      .then((res) => {
        if (res.status === 'SUCCESS' && res.data) {
          if (
            res.data.status == 'LINK_EXPIRED' ||
            res.data.status == 'MANDATE_COMPLETED' ||
            res.data.status == 'MANDATE_APPROVED' ||
            res.data.status == 'MANDATE_REJECT' ||
            res.data.status == 'MANDATE_FAILED' ||
            res.data.status == 'MANDATE_CREATION_SUCCESSFULLY' ||
            res.data.status == 'MANDATE_CREATION_FAILED'
          ) {
            setIsModalOpen(true);
            return;
          }
          setMandateLinkData(res.data as any);
          // console.log('mandate link ', res);
          setAutoPay(res.data.isAutoPay);

          const createddate = new Date();
          const expirtdate = new Date(res.data.nachUserDetails.expiryDate);

          if (createddate >= expirtdate) {
            setIsLinkExpired(true);
          }

          if (res.data.nachBankDetails && res.data.nachBankDetails.length > 0) {
            res.data.nachBankDetails.map((bankItems) => {
              if (bankItems.nachtype == 'AUTOPAY') {
                setAutoPayBankData(bankItems);
              } else if (bankItems.nachtype == 'ENACH') {
                setEnach(true);
                setEnachBankData(bankItems);
              } else if (bankItems.nachtype == 'PNACH') {
                setPnach(true);
                setPnachBankData(bankItems);
              }
            });
          }
        } else {
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  if (isModalOpen || isLinkExpired) {
    return <NoDataFound title="Inactive Link" subTitle="This link is not active anymore." />;
  }

  // console.log('sourceType', sourceType);
  return (
    <div>
      <Loading isLoading={isLoading} />
      <NachWrapper title="Customer Details" className="customerRedirectLink">
        {mandateLinkData ? (
          <>
            <RedirectLinkForm
              isLoading={false}
              autoPay={false}
              data={mandateLinkData}
              sourceType={sourceType}
            />
            {/* <RedirectLinkGrids
              checkedRecord={checkedRecord}
              setCheckedRecord={setCheckedRecord}
              mandateLinkData={mandateLinkData}
            /> */}
            <SourceTypeChoose
              pnach={pnach}
              enach={enach}
              autoPay={autoPay}
              setSourceType={setSourceType}
              sourceType={sourceType}
            />

            {sourceType === 'E-NACH' && enach ? (
              <Enach
                mandateLinkData={mandateLinkData}
                mandateId={mandateId}
                bankData={enachBankData}
              />
            ) : null}
            {sourceType === 'P-NACH' && pnach ? (
              <Pnach
                mandateLinkData={mandateLinkData}
                mandateId={mandateId}
                bankData={pnachBankData}
              />
            ) : null}
            {sourceType === 'AutoPay' && autoPay ? (
              <AutoPay
                ifscCode={autoPayBankData.ifsc}
                accountNumber={autoPayBankData.accountNumber}
                mandateLinkData={mandateLinkData}
                mandateId={mandateId}
                bankData={autoPayBankData}
              />
            ) : null}
          </>
        ) : null}
      </NachWrapper>
    </div>
  );
}

export default CustomerRedirectLink;
